import { GOT_SOCKET_ONLINE_USERS } from './types';

/**
 *
 * @param {array} users_data
 * @returns
 */
export const handleOnlineUsers = (users_data) => {
  return {
    type: GOT_SOCKET_ONLINE_USERS,
    payload: users_data,
  };
};
